import { ensure } from './utils'

export const isBetaFeatureEnabled = process.env['NEXT_PUBLIC_IS_BETA_FEATURE_ENABLED'] === 'true'

// During build time, environment variables might not be available
// This is safe for static generation as the value will be properly set at runtime
export const cognitoClientId = process.env.NEXT_PUBLIC_AWS_COGNITO_CLIENT_ID
  ? ensure(process.env.NEXT_PUBLIC_AWS_COGNITO_CLIENT_ID)
  : 'build-time-placeholder'

export const envName = process.env['NEXT_PUBLIC_ENV_NAME']

// Public API endpoint for analytics tracking (no auth required)
// SSR時はコンテナ間通信用エンドポイントを優先
const apiBase = (typeof window === 'undefined' ? process.env['NEXT_PUBLIC_ORVAL_ENDPOINT'] : undefined)
  ?? process.env['NEXT_PUBLIC_API_ENDPOINT']
  ?? 'http://localhost:8000'
export const publicApiEndpoint = `${apiBase}/public`
